export default __webpack_public_path__ + "static/media/shipping-center-selected.43c94037.svg";